const REPLACEMENTS: Array<[RegExp, string]> = [
  [/‚Äì|â€“/g, "–"],
  [/‚Äî|â€”/g, "—"],
  [/‚Äò|‚Äô|â€˜|â€™/g, "'"],
  [/‚Äú|‚Äù|â€œ|â€/g, '"']
];

export function normalizeExportText(value: unknown): string {
  if (value == null) return "";
  let output = String(value);
  for (const [pattern, replacement] of REPLACEMENTS) {
    output = output.replace(pattern, replacement);
  }
  return output;
}

